(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const metadata = JSON.parse($('#ts-product-meta').textContent);
  const config = JSON.parse($('#ts-config').textContent);
  const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: config.currency || 'USD'}).format(cents / 100);
  const grid = $('.ts-grid');
  const cards = $$('.ts-card', grid);
  let category = 'all';
  const sort = $('#ts-sort');
  function filterAndSort() {
    let ordered = [...cards];
    if (sort.value === 'price-low') ordered.sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price));
    if (sort.value === 'price-high') ordered.sort((a,b) => Number(b.dataset.price) - Number(a.dataset.price));
    if (sort.value === 'title') ordered.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title));
    let count = 0;
    ordered.forEach(card => { card.hidden = category !== 'all' && category !== card.dataset.kind; if (!card.hidden) count++; grid.append(card); });
    $('#ts-product-count').textContent = `${count} ${count === 1 ? 'style' : 'styles'}`;
    $('.ts-empty').hidden = count > 0;
  }
  $$('.ts-filters button').forEach(button => button.addEventListener('click', () => {
    category = button.dataset.filter;
    $$('.ts-filters button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    filterAndSort();
  }));
  sort.addEventListener('change', filterAndSort);
  $('.ts-toolbar').hidden = false;
  filterAndSort();

  const dialog = $('#ts-quickshop');
  const add = $('#ts-add');
  const status = $('#ts-detail-status');
  const choices = $('#ts-variants');
  let currentProduct, selectedVariant, opener, loadingId = 0, adding = false;
  const originalOverflow = document.body.style.overflow;
  const setStatus = text => { status.textContent = text; };
  const selectView = $('#ts-select-view');
  const addedView = $('#ts-added-view');
  const floatBag = $('#ts-float-bag');
  const plural = count => `${count} ${count === 1 ? 'item' : 'items'}`;
  function showSelectView() {
    if (selectView) selectView.hidden = false;
    if (addedView) addedView.hidden = true;
  }
  function renderBag(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    $$('[data-bag-count]').forEach(node => { node.textContent = `(${cart.item_count})`; });
    if (floatBag) {
      $$('[data-float-count]', floatBag).forEach(node => { node.textContent = plural(cart.item_count); });
      $$('[data-float-subtotal]', floatBag).forEach(node => { node.textContent = money(cart.total_price); });
      const wasHidden = floatBag.hidden;
      floatBag.hidden = cart.item_count === 0;
      if (!floatBag.hidden) {
        floatBag.classList.remove('is-bumped');
        void floatBag.offsetWidth;
        floatBag.classList.add(wasHidden ? 'is-entering' : 'is-bumped');
      }
    }
    if (addedView) {
      $('#ts-added-count').textContent = plural(cart.item_count);
      $('#ts-added-subtotal').textContent = money(cart.total_price);
      const threshold = Number(config.freeShippingThreshold) || 0;
      const excluded = (config.freeShippingExcludedVendors || []).map(v => String(v).toLowerCase());
      const ship = $('#ts-ship');
      if (threshold > 0 && Array.isArray(cart.items)) {
        const eligible = cart.items.reduce((sum, item) => excluded.includes(String(item.vendor || '').toLowerCase()) ? sum : sum + Number(item.final_line_price ?? item.line_price ?? 0), 0);
        const remaining = Math.max(0, threshold - eligible);
        $('#ts-ship-fill').style.width = `${Math.min(100, Math.round(eligible / threshold * 100))}%`;
        $('#ts-ship-text').textContent = remaining > 0 ? `You’re ${money(remaining)} away from free shipping.` : 'Your order ships free.';
        ship.hidden = false;
      } else ship.hidden = true;
    }
  }
  function showAddedView(product, variant, cart) {
    if (!addedView) return;
    $('#ts-added-title').textContent = product.title.split(' | ')[0];
    $('#ts-added-variant').textContent = `${variant.title} · ${money(variant.price)}`;
    if (!cart) { $('#ts-added-count').textContent = '—'; $('#ts-added-subtotal').textContent = '—'; $('#ts-ship').hidden = true; }
    selectView.hidden = true; addedView.hidden = false;
    $('#ts-added-title').focus({preventScroll: true});
  }
  function chooseVariant(variant) {
    if (adding) return;
    selectedVariant = variant;
    $$('button', choices).forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.id) === variant.id)));
    $('#ts-detail-price').textContent = money(variant.price);
    $('#ts-detail-color').textContent = `Color: ${variant.title.split(' / ')[0]}`;
    add.disabled = !variant.available;
    add.textContent = variant.available ? `Add to bag — ${money(variant.price)}` : 'Sold out';
    setStatus('');
    $('#ts-view-bag').hidden = true;
    // Only replace the verified image if Shopify supplies an explicit variant image.
    if (variant.featured_image?.src) $('#ts-detail-image').src = variant.featured_image.src;
  }
  async function openQuickshop(handle, trigger) {
    const requestId = ++loadingId;
    opener = trigger;
    const card = cards.find(item => item.dataset.handle === handle);
    const meta = metadata[handle];
    currentProduct = null; selectedVariant = null;
    $('#ts-dialog-title').textContent = meta?.title || card.dataset.title;
    $('#ts-detail-description').textContent = meta?.description || $('.ts-card-description', card).textContent;
    $('#ts-detail-price').textContent = $('.ts-price', card).textContent;
    $('#ts-detail-color').textContent = `Color: ${meta?.color || $('.ts-color', card).textContent}`;
    $('#ts-detail-image').src = $('img', card).src;
    $('#ts-detail-image').alt = $('img', card).alt;
    $('#ts-product-link').href = `${root}products/${encodeURIComponent(handle)}`;
    showSelectView();
    choices.replaceChildren(); add.disabled = true; add.textContent = 'Loading sizes…';
    $('#ts-view-bag').hidden = true; setStatus('Checking current sizes and availability…');
    dialog.showModal(); document.body.style.overflow = 'hidden';
    try {
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error('product');
      const product = await response.json();
      if (requestId !== loadingId || !dialog.open) return;
      if (product.vendor !== 'Tracksmith' || !Array.isArray(product.variants)) throw new Error('product');
      currentProduct = product;
      product.variants.forEach(variant => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.id = variant.id;
        button.textContent = variant.title.split(' / ').at(-1);
        button.setAttribute('aria-label', `${variant.title}${variant.available ? '' : ' — sold out'}`);
        button.setAttribute('aria-pressed', 'false'); button.disabled = !variant.available;
        button.addEventListener('click', () => chooseVariant(variant)); choices.append(button);
      });
      add.textContent = product.available ? 'Select a size' : 'Sold out';
      $('#ts-detail-price').textContent = `${product.price_varies ? 'From ' : ''}${money(product.price)}`;
      setStatus(product.available ? '' : 'This style is currently sold out.');
      if (product.variants.length === 1 && product.variants[0].available) chooseVariant(product.variants[0]);
    } catch {
      if (requestId !== loadingId) return;
      add.textContent = 'Sizes unavailable'; add.disabled = true;
      setStatus('We couldn’t load current sizes. Please use “Full product details & fit” below.');
    }
  }
  $$('[data-quick]').forEach(link => link.addEventListener('click', event => {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (!cards.some(card => card.dataset.handle === link.dataset.quick)) return;
    event.preventDefault(); openQuickshop(link.dataset.quick, link);
  }));
  $('.ts-close').addEventListener('click', () => { if (!adding) dialog.close(); });
  $('#ts-keep-shopping')?.addEventListener('click', () => { if (!adding) dialog.close(); });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    fetch(`${root}cart.js`, {cache: 'no-store'}).then(r => r.ok ? r.json() : null).then(renderBag).catch(() => {});
  });
  dialog.addEventListener('click', event => { if (event.target === dialog && !adding) { const bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close(); } });
  dialog.addEventListener('cancel', event => { if (adding) event.preventDefault(); });
  dialog.addEventListener('close', () => { loadingId++; document.body.style.overflow = originalOverflow; opener?.focus(); });
  add.addEventListener('click', async () => {
    if (!currentProduct || !selectedVariant?.available || adding) return;
    adding = true; add.disabled = true; add.textContent = 'Adding…';
    $$('button', choices).forEach(button => button.disabled = true);
    const variant = selectedVariant;
    try {
      const response = await fetch(`${root}cart/add.js`, {method: 'POST', headers: {'Content-Type': 'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id:variant.id,quantity:1}]})});
      const result = await response.json();
      if (!response.ok) { setStatus(typeof result.description === 'string' ? result.description : 'This size could not be added. Please try another size.'); add.textContent = 'Try again'; }
      else {
        setStatus(`${currentProduct.title.split(' | ')[0]} · ${variant.title} added to your bag.`);
        add.textContent = 'Add another'; $('#ts-view-bag').hidden = false;
        let cart = null;
        try { const cartResponse = await fetch(`${root}cart.js`, {cache:'no-store'}); if (cartResponse.ok) cart = await cartResponse.json(); } catch { /* Successful add remains confirmed even if the count refresh fails. */ }
        showAddedView(currentProduct, variant, cart);
        renderBag(cart);
      }
    } catch { setStatus('We couldn’t confirm the add. Check your bag before trying again.'); add.textContent = 'Try again'; $('#ts-view-bag').hidden = false; }
    finally { adding = false; add.disabled = false; $$('button', choices).forEach(button => { button.disabled = !currentProduct.variants.find(v => v.id === Number(button.dataset.id))?.available; }); }
  });
})();
